module.exports = __webpack_public_path__ + "img/2026b767-edcb-4441-b70e-a6d94ae6ebb9.74fac151.webp";